import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { queryMemberInfoAsync } from './thunks';

const initialState: IUser.UserSliceState = {
  userInfo: undefined,
  lastTime: 0,
  loading: false,
  loginUser: false,
  userCertify: [],
  lastCertifyStatus: 0,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserCertify: (state, action: PayloadAction<string[]>) => {
      state.userCertify = action.payload;
    },
    setLoginStatus: (state, action: PayloadAction<boolean>) => {
      state.loginUser = action.payload;
    },
    setLastCertifyStatus: (state, action: PayloadAction<number>) => {
      state.lastCertifyStatus = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(queryMemberInfoAsync.pending, (state, _action) => {
        state.loading = true;
      })
      .addCase(queryMemberInfoAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.userInfo = action.payload;
          state.loginUser = true;
          state.lastTime = Date.now();
        }
      })
      .addCase(queryMemberInfoAsync.rejected, (state, _action) => {
        state.loading = false;
        state.lastTime = Date.now();
      });
  },
});
